import React, { useEffect, useRef } from "react";
import { Configure, Index, InstantSearch } from "react-instantsearch";
import { history } from "instantsearch.js/es/lib/routers";

import "instantsearch.css/themes/reset.css";

import algoliasearch from "algoliasearch";

import "./SearchOverlay.scss";

import FiltersOverlay from "../FiltersOverlay/FiltersOverlay";

import HitListing from "../../Hits/HitListing/HitListing";
import RefinementSidebar from "../../Refinements/RefinementSidebar";
import SearchHeader from "../../SearchHeader/SearchHeader";
import CustomSuggestionsCollector from "../../Suggetions/CustomSuggestionsCollector";

import CustomSuggestionHits from "../../Suggetions/CustomSuggestionHits";

import { useDispatch, useSelector } from "react-redux";
import { overlayActions } from "../../../store/redux/store";

import gsap from "gsap";
import { Transition } from "react-transition-group";
import { useGSAP } from "@gsap/react";

import {
    searchOverlayOnEnter,
    searchOverlayOnExit,
} from "./search-overlay-animations";

gsap.config({
    nullTargetWarn: false,
    trialWarn: false,
});
const SearchOverlay = (props) => {
    const {
        APP_ID,
        SEARCH_KEY,
        SEARCH_INDEX,
        SEARCH_INDEX_QUERY_SUGGESTIONS,
        INSIGHTS_USER_TOKEN,
    } = useSelector((state) => state.config);

    const algoliaClient = algoliasearch(APP_ID, SEARCH_KEY);

    const searchClient = {
        ...algoliaClient,
        search(requests) {
            return algoliaClient.search(requests);
        },
    };

    const searchClientRef = useRef(searchClient);

    const routing = {
        router: history({
            cleanUrlOnDispose: false,
        }),
    };

    useEffect(() => {
        if (window.dataLayer) {
            window.dataLayer.push({
                algoliaUserToken: INSIGHTS_USER_TOKEN,
            });
        } else {
            return;
        }
        // eslint-disable-next-line
    }, []);

    const dispatch = useDispatch();
    const setAllFiltersOverlay = () => {
        dispatch(overlayActions.initAllFiltersOverlay());
    };
    const resetAllFiltersOverlay = () => {
        dispatch(overlayActions.resetAllFiltersOverlay());
    };

    const initAllFiltersOverlay = useSelector(
        (state) => state.overlay.initAllFiltersOverlay,
    );
    useEffect(() => {
        const timeoutId = setTimeout(setAllFiltersOverlay, 2500);
        return () => {
            resetAllFiltersOverlay();
            clearTimeout(timeoutId);
        };
        // eslint-disable-next-line
    }, []);
    const searchOverlayRef = useRef(null);
    const isSearchOpen = useSelector((state) => state.overlay.isSearchOpen);

    const nodeRef = useRef(null);

    useGSAP(() => {
        gsap.set(searchOverlayRef.current, {
            autoAlpha: 0,
        });
    });

    return (
        <Transition
            nodeRef={nodeRef}
            in={isSearchOpen}
            appear
            timeout={250}
            onEnter={searchOverlayOnEnter}
            onExit={searchOverlayOnExit}
            unmountOnExit={false}
        >
            {(state) => (
                <div
                    id="search-overlay"
                    ref={searchOverlayRef}
                    style={{ pointerEvents: isSearchOpen ? "all" : "none" }}
                >
                    <InstantSearch
                        searchClient={searchClientRef.current}
                        indexName={SEARCH_INDEX}
                        routing={routing}
                        future={{
                            preserveSharedStateOnUnmount: true,
                            persistHierarchicalRootCount: true,
                        }}
                    >
                        <Configure
                            clickAnalytics={true}
                            userToken={INSIGHTS_USER_TOKEN}
                            ruleContexts={[
                                "manufacturerslider",
                                "advertisements",
                                "noresults-links",
                                "listingbanner",
                            ]}
                        />

                        <>
                            <SearchHeader />
                            {SEARCH_INDEX_QUERY_SUGGESTIONS ? (
                                <>
                                    <Index
                                        indexName={
                                            SEARCH_INDEX_QUERY_SUGGESTIONS
                                        }
                                        indexId="suggestions"
                                    >
                                        <CustomSuggestionsCollector />
                                    </Index>
                                    <CustomSuggestionHits />
                                </>
                            ) : null}
                            <Index indexName={SEARCH_INDEX} indexId="products">
                                <div className="search-overlay-content">
                                    {/* 10 filters */}
                                    <RefinementSidebar />
                                    {/* search results */}
                                    <HitListing />
                                </div>
                                {initAllFiltersOverlay ? (
                                    <FiltersOverlay />
                                ) : null}
                            </Index>
                        </>
                    </InstantSearch>
                </div>
            )}
        </Transition>
    );
};

export default SearchOverlay;
